import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useState } from 'react'

type ScheduleStatusSource = { is_paid?: boolean, is_written_off?: boolean }

// Kolejnosc ma znaczenie: is_paid -> is_written_off -> do zaplaty.
// Pola sa tylko w v1/user/payment/schedule - w pozostalych miejscach nie pokazujemy statusu.
const getScheduleStatus = ({ is_paid, is_written_off }: ScheduleStatusSource) => {
  if (is_paid === undefined && is_written_off === undefined) return null
  if (is_paid) return { modifier: 'paid', label: 'scheduleStatusPaid' }
  if (is_written_off) return { modifier: 'written-off', label: 'scheduleStatusWrittenOff' }
  return { modifier: 'to-pay', label: 'scheduleStatusToPay' }
}

const Schedule: React.FC<{ schedule?: warehouse.MonthlyScheduleItem[] }> = ({ schedule }) => {
  const [isExpanded, expand] = useState(false)
  const { t } = useTranslation('basket')

  return (
    <>
      <div className='orderInfo__summary__schedule'>
        {schedule?.map(({ title, price_sum, description, list, ...month }, idx) => {
          const monthStatus = getScheduleStatus(month)
          return <div
          key={idx}
          className={`orderInfo__summary__schedule__row${monthStatus ? ` --${monthStatus.modifier}` : ''}`}>
          <div className='group'>
            <div className='orderInfo__summary__schedule__content'>
              <div>
                {title}
                {monthStatus && <span className={`orderInfo__summary__schedule__status --${monthStatus.modifier}`}>
                  {t(monthStatus.label)}
                </span>}
              </div>
              {!isExpanded && <div>{description}</div>}
            </div>
            {!isExpanded && <div className='orderInfo__summary__schedule__price'>{displayPrice(price_sum)}</div>}
          </div>
          {isExpanded && list && list.map(({ text, price, type, ...item }, listIdx) => {
            const itemStatus = getScheduleStatus(item)
            return <div
              key={listIdx}
              className={`orderInfo__summary__schedule__details group --${type}${itemStatus ? ` --${itemStatus.modifier}` : ''}`}>
              <div>
                {text}
                {itemStatus && <span className={`orderInfo__summary__schedule__status --${itemStatus.modifier}`}>
                  {t(itemStatus.label)}
                </span>}
              </div>
              <div>{displayPrice(price)}</div>
            </div>
          })}
          {isExpanded && <div className='orderInfo__summary__schedule__price --right'>
            {displayPrice(price_sum)}
          </div>}
        </div>
        })}
      </div>
      <div
        className='orderInfo__summary__footer'
        onClick={() => {
          expand(p => !p)
        }}>
        {t(isExpanded ? 'collapse' : 'expand')}
      </div>
    </>
  )
}

export default Schedule